export const UPDATE_MODE_VIEW = 'UPDATE_MODE_VIEW';
export const SELECT_RESULT = 'SELECT_RESULT';
export const UPDATE_SETTING = 'UPDATE_SETTING';
export const KEEP_SETTING = 'KEEP_SETTING';
export const UPDATE_RESULT_GRID_PAGINATION = 'UPDATE_RESULT_GRID_PAGINATION';
export const KEEP_RESULT_GRID_PAGINATION = 'KEEP_RESULT_GRID_PAGINATION';
